var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(!_vm.isHorizontal)?_c('div',[_vm._v(_vm._s(_vm.field.name))]):_vm._e(),_c('flat-pickr',{staticClass:"timeNoBackground w-100",attrs:{"id":_vm.uniqueId,"config":{
      enableTime: true,
      dateFormat: 'H:i',
      time_24hr: true,
      noCalendar: true,
      enableSeconds: false,
      onOpen: _vm.setCurrentTime
    },"disabled":_vm.isFieldDisabled},on:{"input":_vm.onChange},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}}),_c('div',{staticClass:"d-flex flex-column"},[(_vm.hint)?_c('span',{staticClass:"textHint"},[_vm._v(_vm._s(_vm.hint))]):_vm._e(),(_vm.error)?_c('span',{staticClass:"text-error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }